import useSharedFilterStyle from './hooks/useSharedFilterStyle'

export function VerticalFilterDivider(props: { noColor?: boolean }) {
  const classes = useSharedFilterStyle()
  return <div className={props.noColor ? classes.dividerRootNoColor : classes.dividerRoot} />
}
